import React, { useEffect, useRef, useState } from "react";
import styles from "./ArtistRepresentativeAccount.module.scss";
import CropImagePopup from "components/popups/CropImagePopup";
import RadioInput from "components/radioInput/RadioInput";
import placeholderImage from "../../../assets/images/placeholder.png";
import uploadImage from "../../../assets/images/upload.png";
import SearchIcon from "components/svgs/SearchIcon";
import DeleteIcon from "components/svgs/DeleteIcon";
import Dropdown from "components/dropdown/Dropdown";
import { countryOptions } from "utils/DropdownOptions";

const ArtistRepresentativeAccount = () => {
  const portraitRef = useRef(null);
  const documentsRef = useRef(null);
  const [formData, setFormData] = useState({
    objective: "introduce",
    firstName: "",
    lastName: "",
    selectedPortrait: null,
    biography: "",
    country: "",
    documents: [],
  });

  const [showPortraitCropPopup, setShowPortraitCropPopup] = useState(false);
  const [selectedCropImage, setSelectedCropImage] = useState(null);

  const handlePortraitDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0 && !formData.selectedPortrait) {
      setFormData({ ...formData, selectedPortrait: droppedFiles[0] });
    }
  };

  const handlePortraitChange = (event) => {
    if (event.target.files.length > 0 && !formData.selectedPortrait) {
      setFormData({ ...formData, selectedPortrait: event.target.files[0] });
    }
  };

  const handleDocumentsChange = (event) => {
    if (event.target.files.length > 0) {
      setFormData({
        ...formData,
        documents: [...formData.documents, event.target.files[0]],
      });
    }
  };

  const handleDocumentDelete = (indexToRemove) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter(
        (_, index) => index !== indexToRemove
      ),
    }));
  };

  const handleSaveClick = async () => {
    console.log("formData", formData);
  };

  useEffect(() => {
    if (selectedCropImage) {
      if (selectedCropImage.type === "portrait") {
        setFormData({ ...formData, selectedPortrait: selectedCropImage.file });
      } else if (selectedCropImage.type === "document") {
        setFormData((prevFormData) => ({
          ...prevFormData,
          documents: prevFormData.documents.map((doc, i) =>
            i === selectedCropImage.index ? selectedCropImage.file : doc
          ),
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCropImage]);

  useEffect(() => {
    console.log("formData", formData);
  }, [formData]);

  return (
    <div className={styles.createArtistRepresentativeAccountPage}>
      <h2 className={styles.title}>CREATE ARTIST REPRESENTATIVE ACCOUNT</h2>
      <div className={styles.form}>
        {/* <div className={styles.formGroup}>
          <label></label>
          <h2 className={styles.formTitle}>
            CREATE ARTIST REPRESENTATIVE ACCOUNT
          </h2>
        </div> */}
        <div className={styles.formGroup}>
          <label>Select your objective *</label>
          <div className={styles.radioGroup}>
            <RadioInput
              name="objective"
              value="introduce"
              label="Introduce the work of an Artist/s"
              isChecked={formData.objective === "introduce"}
              handleChange={(value) =>
                setFormData({ ...formData, objective: value })
              }
            />
            <RadioInput
              name="objective"
              value="sell"
              label="Sell the work of an Artist/s"
              isChecked={formData.objective === "sell"}
              handleChange={(value) =>
                setFormData({ ...formData, objective: value })
              }
            />
          </div>
        </div>
        <div className={styles.formGroup}>
          <label className={styles.hasSub}>
            <sub>(Representative)</sub>First Name *
          </label>
          <input
            type="text"
            value={formData.firstName}
            onChange={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.hasSub}>
            <sub>(Representative)</sub>Last Name *
          </label>
          <input
            type="text"
            value={formData.lastName}
            onChange={(e) =>
              setFormData({ ...formData, lastName: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label></label>
          <div className={styles.portraitContainer}>
            <h2>Your Portrait</h2>
            {!formData.selectedPortrait ? (
              <div
                className={styles.uploadFileContainer}
                onDrop={handlePortraitDrop}
                onDragOver={(event) => event.preventDefault()}
                onClick={() => portraitRef.current?.click()}
              >
                <img
                  className={styles.placeholderImage}
                  src={placeholderImage}
                  alt="placeholder"
                />
                <img
                  className={styles.uploadImage}
                  src={uploadImage}
                  alt="placeholder"
                />
                <div className={styles.uploadFileText}>Upload a file</div>
                <div className={styles.dragDropText}>
                  Drag and drop files here
                </div>
                <input
                  style={{ display: "none" }}
                  type="file"
                  accept="image/*"
                  ref={portraitRef}
                  onChange={handlePortraitChange}
                />
              </div>
            ) : (
              <div className={styles.selectedPortraitContainer}>
                <div className={styles.selectedPortrait}>
                  <img
                    src={URL.createObjectURL(formData.selectedPortrait)}
                    alt={formData.selectedPortrait?.name}
                  />
                </div>
                <div className={styles.imageActions}>
                  <div
                    className={styles.cropImage}
                    onClick={() => {
                      setShowPortraitCropPopup(true);
                      setSelectedCropImage({
                        file: formData.selectedPortrait,
                        type: "portrait",
                      });
                    }}
                  >
                    <span>Crop</span>
                    <SearchIcon />
                  </div>
                  <div
                    className={styles.deleteImage}
                    onClick={() =>
                      setFormData({ ...formData, selectedPortrait: null })
                    }
                  >
                    <span>Delete</span>
                    <DeleteIcon />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.formGroup}>
          <label>
            Biography * <span>Max. 500 words</span>
          </label>
          <textarea
            placeholder="Type some text here"
            rows={7}
            value={formData.biography}
            onChange={(e) =>
              setFormData({ ...formData, biography: e.target.value })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Country *</label>
          <Dropdown
            placeholder="Choose a Country..."
            options={countryOptions}
            selectedValue={formData.country}
            handleChange={(value) =>
              setFormData({
                ...formData,
                country: value,
              })
            }
          />
        </div>
        <div className={styles.formGroup}>
          <label>Documents *</label>
          <div className={styles.documentsContainer}>
            {formData.documents.length ? (
              <div className={styles.selectedDocumentsGrid}>
                {formData.documents.map((document, index) => {
                  return (
                    <div
                      key={index + document.name}
                      className={styles.selectedDocumentContainer}
                    >
                      <div className={styles.selectedDocument}>
                        <img
                          src={URL.createObjectURL(document)}
                          alt={document.name}
                        />
                      </div>
                      <div className={styles.imageActions}>
                        <div
                          className={styles.cropImage}
                          onClick={() => {
                            setShowPortraitCropPopup(true);
                            setSelectedCropImage({
                              file: document,
                              type: "document",
                              index,
                            });
                          }}
                        >
                          <span>Crop</span>
                          <SearchIcon />
                        </div>
                        <div
                          className={styles.deleteImage}
                          onClick={() => handleDocumentDelete(index)}
                        >
                          <span>Delete</span>
                          <DeleteIcon />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            {formData.documents.length < 2 ? (
              <>
                <div
                  className={styles.uploadFileContainer}
                  onClick={() => documentsRef.current?.click()}
                >
                  <img
                    className={styles.uploadImage}
                    src={uploadImage}
                    alt="placeholder"
                  />
                  <div className={styles.uploadFileText}>Upload a file</div>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    accept="image/*"
                    ref={documentsRef}
                    onChange={handleDocumentsChange}
                  />
                </div>
                <p className={styles.helperText}>
                  Please upload documents to verify your identity
                </p>
              </>
            ) : null}
          </div>
        </div>
        <div className={styles.formGroup}>
          <label></label>
          <div className={styles.saveBtnContainer}>
            <button onClick={handleSaveClick}>Save Information</button>
          </div>
        </div>
      </div>
      {showPortraitCropPopup ? (
        <CropImagePopup
          showPopup={showPortraitCropPopup}
          setShowPopup={setShowPortraitCropPopup}
          selectedImage={selectedCropImage}
          setSelectedImage={setSelectedCropImage}
        />
      ) : null}
    </div>
  );
};

export default ArtistRepresentativeAccount;
